export default __webpack_public_path__ + "static/media/Chevin_Bold.cb15f839.ttf";